export default function DownloadButton ({url, children, download}) {

    return (
        <div>
            <a href={url}
                rel="noreferrer noopener"
                target="_blank"
                download={download ? true : false}
                className="py-3 mb-8 px-5 text-sm font-medium text-center text-white rounded-lg bg-green-500 sm:w-fit hover:bg-green-600 dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800">{children}</a>
        </div>

    )
}